import envs from "./envs";

export default [
  ["/", envs.homePortal],
  ["/home", envs.homePortal],
  [
    "/seguro-apoio-familia-caixa-tem",
    `${envs.hostStaticCdn}/AreaAberta/CondicoesGerais/Vida/SeguroApoioFamiliaMicrosseguroCaixaTem/CaixaVidaePrevidencia-Condicoes-Gerais-Apoio-Família-Caixa-Tem.pdf`,
  ],
];
